module.exports = __webpack_public_path__ + "img/video3-intro.8845ec00.png";